import React from "react";
import { NavLink } from "react-router-dom";
import blog_card_img1 from "../assets/images/dummy/blog_card_img1.png";
import testimonials_img1 from "../assets/images/dummy/testimonials_img1.png";

const BlogCard = ({
  blog,
  defaultUserImage,
  defaultImage,
  getDate,
  removeHTMLTags,
}) => {
  return (
    <NavLink to={`/blog-details/${blog.slug}`} className="block h-full group ">
      <div className="flex flex-col h-full overflow-hidden transition-shadow duration-300 bg-white border border-gray-100 shadow-md rounded-xl hover:shadow-lg">
        {/* Author and Date */}
        <div className="flex items-center justify-between bg-[url('https://img.freepik.com/premium-vector/modern-abstract-blue-white-technology-background-design-vector-illustration_29865-5835.jpg')] bg-center bg-cover bg-no-repeat px-4  pt-4">
          <div className="flex items-center mb-3">
            {blog.profile_pic ? (
              <img
                alt={blog.name || "Author"}
                className="border-t-2 border-b object-cover w-[2.6rem] h-[2.6rem] border-2 p-[0.1rem] border-[#0C4645] mr-2 rounded-full"
                src={`${process.env.REACT_APP_SOCKET_URL}/upload/${
                  blog.created_by === "coach" ? "coach" : "users"
                }/profile/${blog.profile_pic}`}
                onError={defaultUserImage}
              />
            ) : (
              <img
                alt="Default author"
                className="border-t-2 border-b object-cover w-[2.6rem] h-[2.6rem] border-2 p-[0.1rem] border-[#0C4645] mr-2 rounded-full"
                src={testimonials_img1} // Make sure to import this
              />
            )}
            <span className="text-sm font-semibold text-gray-700">
              {blog.name || "Jack Mick"}
            </span>
          </div>
          <span className="text-xs text-gray-500">
            {getDate(blog.blog_date || blog.updated_at)}
          </span>
        </div>

        {/* Blog Image */}
        <div className="w-full h-48 overflow-hidden">
          {blog.image ? (
            <img
              alt={blog.title || "Blog image"}
              className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
              src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/resized/${blog.image}`}
              onError={defaultImage}
            />
          ) : (
            <img
              alt="Default blog"
              className="object-cover w-full h-full"
              src={blog_card_img1} // Make sure to import this
              onError={defaultImage}
            />
          )}
        </div>

        {/* Blog Content */}
        <div className="p-3 bg-[url('https://img.freepik.com/premium-vector/modern-abstract-blue-white-technology-background-design-vector-illustration_29865-5835.jpg')] bg-center bg-cover bg-no-repeat">
          <div className="flex-grow p-4 bg-slate-900/40 rounded-xl">
            <h3 className="mb-2 text-lg font-semibold text-gray-50 line-clamp-2">
              {blog?.title}
            </h3>
            <p className="mb-4 text-sm text-slate-100 line-clamp-3">
              {removeHTMLTags(blog.content).substring(0, 115)}...
            </p>
            <div className="text-sm font-medium text-indigo-600 transition-colors group-hover:text-indigo-700">
              Read More
            </div>
          </div>
        </div>
      </div>
    </NavLink>
  );
};

export default BlogCard;
